import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 16,
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
  },
  addInformationContainer: {
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 8,
  },
  addInformation: {
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
  },
  informationContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 8,
    padding: 0,
  },
  icon: {
    width: 24,
    height: 'auto',
    marginRight: 8,
    color: theme.palette.secondary.dark,
  },
  name: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))
